import { Col, Row } from "react-bootstrap";
import DropDown from "../../Common/Forms/DropDown";
import DropDownListMultiCheckboxOptions from "../../Common/Forms/DropDownListMultiCheckboxOptions";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDatePickerNative from "../../Common/Forms/FromToDatePickerNative";

const KlagerapportFilterForm = ({ ...props }) => {
  return (
    <form onSubmit={props.handleSubmit} className="SearchHistorikkForm">
      <div className="searchHistorikkOverskrift">
        Klagestatistikk basert på ileggelsesdato
      </div>
      <div className="filter-flexbox-container klager-filter-flexbox">
        <FromToDatePickerNative
          fra={{
            id: "fraDato",
            name: "fraDato",
            label: "Dato fra",
            placeholder: "Velg dato",
            value: props.klageRapportFilterFormState.fraDato,
            validationError:
              props.klageRapportFilterFormState.fraDatoValidationErrorText,
          }}
          til={{
            id: "tilDato",
            name: "tilDato",
            label: "Dato til",
            placeholder: "Velg dato",
            value: props.klageRapportFilterFormState.tilDato,
            validationError:
              props.klageRapportFilterFormState.tilDatoValidationErrorText,
          }}
          onChange={props.handleChange}
        />
        <DropDownListMultiCheckboxOptions
          label="Ileggelsestype"
          name="selectedIleggelsestyper"
          items={props.ileggelsestyper.filter((it) => it.navn !== "Avgift")}
          selected={props.klageRapportFilterFormState.selectedIleggelsestyper}
          title={
            props.klageRapportFilterFormState.selectedIleggelsestyper.length > 0
              ? `${props.klageRapportFilterFormState.selectedIleggelsestyper.length} valg`
              : "Velg"
          }
          onChange={props.handleChange}
        />
        <DropDown
          id="sortOptions"
          name="selectedSort"
          label="Sorter på"
          title="Velg"
          selected={props.klageRapportFilterFormState.selectedSort}
          items={props.sortOptions}
          onChange={props.handleChange}
        />
      </div>
      <Row>
        <Col sm={12}>{props.error}</Col>
      </Row>
      <Row>
        <Col sm={12}>
          <FormButtonsForCloseAndSubmit
            closeText="Tilbakestill"
            submitText="Søk"
            onClose={props.handleChangeToInitState}
            onSubmit={props.handleSubmit}
            showCloseSpinner={false}
            showSubmitSpinner={props.showSokSpinner}
          />
        </Col>
      </Row>
    </form>
  );
};

export default KlagerapportFilterForm;
